module.exports = __webpack_public_path__ + "static/media/WinterborneHome1Jacket.a03d707b.jpg";